import { Box, styled } from '@mui/material';

import { UIconImgStyle } from './UniversityIcon.types';

export const UIconContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',

  '@media screen and (max-width: 1280px)': {
    flexDirection: 'column',
  },
}));
export const UIconImg = styled('img')(({ reversed }: UIconImgStyle) =>
  reversed
    ? {
        filter: 'brightness(0) invert(1)',
      }
    : {},
);
